import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FormsModule } from '@angular/forms';
import { NgbTimepickerModule } from '@ng-bootstrap/ng-bootstrap';
import { TimeControlComponent } from '../components/time-control.component';
import { CoreModule } from 'src/core/modules/core.Module';
import { FormModule } from 'src/core/modules/form.Module';
import { SelectDropDownModule } from 'ngx-select-dropdown';


@NgModule({
    declarations: [
        TimeControlComponent,

    ],
    imports: [
        CommonModule,
        FormsModule,
        SelectDropDownModule
    ],
    exports: [
        TimeControlComponent,
    ]
})
export class TimeControlModule { }
